import React from "react";
import { defaultCodeTemplatesNoSDK } from "../helpers";
import { SignupCTA } from "../SignupCTA";
import { Tabs } from "../Tabs";
import { ClassCEndpoint } from "../ClassCEndpoint";
import { PageLayout } from "../layouts/PageLayout";
import { BadgeImage } from "../Badge";
import { useEffect } from "react";
import { rudderStackLocation } from "../Track";
import { BreadCrumb } from "../BreadCrumb";
import { Flex, Table } from "@radix-ui/themes";

export function ClassCPage({ classC, allClassC, userKey }) {
    useEffect(() => {
        rudderStackLocation();
    }, []);
    const appname = classC.application.slug;
    const { displayname, slug, description, blockchains, imgwhite } = classC.application;

    const balances = slug === "bitcoin" ? null : require(`../../data/protocols/${appname}-balances.json`),
        transactions = require(`../../data/protocols/${appname}-transactions.json`),
        marketdata = slug === "bitcoin" ? null : require(`../../data/protocols/${appname}-market-data.json`),
        markets = slug === "bitcoin" ? null : require(`../../data/protocols/${appname}-markets.json`),
        tokens = (slug === "frax" || slug === "balancer") ? require(`../../data/protocols/${appname}-tokens.json`) : null;

    const responsiveImage = imgwhite.responsiveImage;

    const title = `${displayname} Wallet Balances and Transactions`;

    return (
        <>
            <BreadCrumb title={title} />
            <PageLayout>
                <div>
                    <Flex direction="column" gap="3">
                        <h1 className="spacer">{title}</h1>
                        <BadgeImage href={null} image={responsiveImage} />
                        <p className="spacer">{description}</p>
                        <SignupCTA displayName={displayname} description={""} title={""} />
                        <h2 id="quick-facts">{displayname} Quick Facts</h2>
                        <Table.Root variant="surface">
                            <Table.Header>
                                <Table.Row>
                                    <Table.ColumnHeaderCell colSpan={2}>
                                        Blockchains supported
                                    </Table.ColumnHeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                <Table.Row>
                                    {blockchains && blockchains.map((b, i) => {
                                        return <Table.Cell key={i}>
                                            <code className="pill">{b.chainname}</code>
                                        </Table.Cell>;
                                    })}
                                </Table.Row>
                            </Table.Body>
                        </Table.Root>
                        <h2 id="code-samples">Code Samples</h2>
                        {slug === "bitcoin"
                            ? <ClassCEndpoint
                                userKey={userKey}
                                allClassC={allClassC}
                                noPrefilledValues={false}
                                codeTemplates={defaultCodeTemplatesNoSDK}
                                endpointType="transactions"
                                slug={slug}
                                schema={transactions} />
                            : <Tabs activeTab="Wallet Balances">
                                <div data-label="Wallet Balances">
                                    <ClassCEndpoint
                                        userKey={userKey}
                                        allClassC={allClassC}
                                        noPrefilledValues={false}
                                        codeTemplates={defaultCodeTemplatesNoSDK}
                                        endpointType="balances"
                                        slug={slug}
                                        schema={balances} />
                                </div>
                                <div data-label="Wallet Transactions">
                                    <ClassCEndpoint
                                        userKey={userKey}
                                        allClassC={allClassC}
                                        noPrefilledValues={false}
                                        codeTemplates={defaultCodeTemplatesNoSDK}
                                        endpointType="transactions"
                                        slug={slug}
                                        schema={transactions} />
                                </div>
                                <div data-label="Market Data">
                                    <ClassCEndpoint
                                        userKey={userKey}
                                        allClassC={allClassC}
                                        noPrefilledValues={false}
                                        codeTemplates={defaultCodeTemplatesNoSDK}
                                        endpointType="marketdata"
                                        slug={slug}
                                        schema={marketdata} />
                                </div>
                                <div data-label="Markets">
                                    <ClassCEndpoint
                                        userKey={userKey}
                                        allClassC={allClassC}
                                        noPrefilledValues={false}
                                        codeTemplates={defaultCodeTemplatesNoSDK}
                                        endpointType="markets"
                                        slug={slug}
                                        schema={markets} />
                                </div>
                                <div data-label="Tokens">
                                    <ClassCEndpoint
                                        userKey={userKey}
                                        allClassC={allClassC}
                                        noPrefilledValues={false}
                                        codeTemplates={defaultCodeTemplatesNoSDK}
                                        endpointType="tokens"
                                        slug={slug}
                                        schema={tokens} />
                                </div>
                            </Tabs>}
                        <style jsx>
                            {`
                            .spacer {
                                padding-right: 115px;
                            }
                            .pill {
                                margin-right: 10px;
                            }
                        `}
                        </style>
                    </Flex>
                </div>
            </PageLayout></>
    );
}
